// jQuery
jQuery(function($){
	// -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $('.totop');

  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 300, 'swing');
    return false;
  });
});

// JavaScript

// 
// 文字の背景アニメーション
// 
window.addEventListener("load", () => {
  const elements = document.querySelectorAll(".js-backColor");
  if (elements.length === 0) return; // 要素がなければ処理を中止

  const isInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top < window.innerHeight &&
      rect.bottom > 0
    );
  };

  const checkVisibility = () => {
    elements.forEach((el) => {
      if (isInViewport(el)) {
        el.classList.add("_isActive");
      }
    });
  };

  window.addEventListener("scroll", checkVisibility);
  window.addEventListener("resize", checkVisibility);
  checkVisibility(); // 初回チェック
});



// グリッチアニメーション

window.addEventListener('load', function () {

  // Main visual Glitch
  function glitchJS(element, intensity = 10, interval = 80, stillChance = 0.2, stillDuration = 5) {
    let stillCounter = 0;

    setInterval(() => {
      if (stillCounter > 0) {
        element.style.transform = 'translate(0, 0)';
        stillCounter--;
        return;
      }

      if (Math.random() < stillChance) {
        stillCounter = stillDuration;
        element.style.transform = 'translate(0, 0)';
      } else {
        const offsetX = (Math.random() - 0.5) * intensity;
        const offsetY = (Math.random() - 0.5) * intensity;
        element.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
      }
    }, interval);
  }

  // glitchJSの適用
  document.querySelectorAll('.paintC').forEach(el => glitchJS(el, 2, 60, 0.25, 3));
  document.querySelectorAll('.paintR').forEach(el => glitchJS(el, 3, 40, 0.2, 4));

  // Image Glitch
  setTimeout(() => document.body.classList.add('render'), 60);

  const navdemos = Array.from(document.querySelectorAll('nav.demos > .demo'));
  const total = navdemos.length;
  const current = navdemos.findIndex(el => el.classList.contains('demo--current'));

  const navigate = (linkEl) => {
    document.body.classList.remove('render');
    document.body.addEventListener('transitionend', () => {
      window.location = linkEl.href;
    }, { once: true });
  };

  navdemos.forEach(link => {
    link.addEventListener('click', (ev) => {
      ev.preventDefault();
      navigate(ev.currentTarget);
    });
  });

  document.addEventListener('keydown', (ev) => {
    const keyCode = ev.keyCode || ev.which;
    let linkEl;
    if (keyCode === 37) {
      linkEl = current > 0 ? navdemos[current - 1] : navdemos[total - 1];
    } else if (keyCode === 39) {
      linkEl = current < total - 1 ? navdemos[current + 1] : navdemos[0];
    } else {
      return;
    }
    navigate(linkEl);
  });

  // imagesLoaded の代替（background images 対応）
  const glitchImgs = document.querySelectorAll('.glitch__img');
  let loadedCount = 0;

  glitchImgs.forEach(img => {
    const style = getComputedStyle(img);
    const bg = style.backgroundImage.match(/url\(["']?([^"')]+)["']?\)/);
    if (bg && bg[1]) {
      const bgImg = new Image();
      bgImg.src = bg[1];
      bgImg.onload = () => {
        loadedCount++;
        if (loadedCount === glitchImgs.length) {
          document.body.classList.remove('loading');
          document.body.classList.add('imgloaded');
        }
      };
    }
  });

  // Text Glitch
  document.querySelectorAll('.txtGlitch span').forEach(function (textbox) {
    const nodes = Array.from(textbox.childNodes);
    textbox.innerHTML = '';

    nodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent.split('').forEach(function (c) {
          const span = document.createElement('span');
          span.className = 'txt_glitch';
          span.setAttribute('data-text', c);
          span.textContent = c;
          textbox.appendChild(span);
        });
      } else {
        textbox.appendChild(node.cloneNode(true));
      }
    });
  });

});


// 
// タブ
// 
document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".tabs");

    tabs.forEach(tabContainer => {
        const buttons = tabContainer.querySelectorAll(".tabs-btn");
        const contents = tabContainer.querySelectorAll(".tabs-cont");

        buttons.forEach(button => {
            button.addEventListener("click", () => {
                // 全てのボタンとコンテンツを非アクティブ化
                buttons.forEach(btn => btn.classList.remove("_active"));
                contents.forEach(content => content.classList.remove("_active"));

                // 対応するタブをアクティブ化
                button.classList.add("_active");
                const tabId = button.dataset.tab;
                tabContainer.querySelector(`#${tabId}`).classList.add("_active");
            });
        });
    });
});


// 
// スプライド用
// 
document.addEventListener('DOMContentLoaded', () => {
  const el1 = document.querySelector('#case');
  if (el1) {
    new Splide(el1, {
      type: 'loop',     // 無限ループ
      arrows: false,    // 矢印を非表示
    }).mount();
  }

  const el2 = document.querySelector('#splide1');
  if (el2) {
    new Splide(el2, {
      type: 'loop',     // 無限ループ
      arrows: false,    // 矢印を非表示
      autoplay: true,     // 自動再生を有効にする
      interval: 3000,     // 3秒ごとにスライド（ミリ秒）
    }).mount();
  }
});



// 一番上から少しでもスクロールしたらクラスをつける
document.addEventListener("scroll", function () {
  const header = document.querySelector(".header"); // l-headerクラスを取得
  if (window.scrollY > 0) {
    header.classList.add("_isVisible"); // スクロールしている場合、_fixedクラスを追加
  } else {
    header.classList.remove("_isVisible"); // スクロール位置が0なら、_fixedクラスを削除
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const fixBtn = document.querySelector('.fixBtn');
  const toggleBtn = document.getElementById('js-fixBtn');

  // 初期状態で隠す（JSが有効な場合）
  if (fixBtn) {
    fixBtn.classList.add('_isHidden');
  }

  // クリックで開閉を切り替え
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      fixBtn.classList.toggle('_isHidden');
    });
  }
});




// 
// ハンバーガーメニュー用のJS
// 
document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector("header");
    const toggleButton = document.querySelector(".hamburger");
    const navMenu = document.querySelector("#nav-menu");
    const menuLinks = header.querySelectorAll("a");
  
    toggleButton.addEventListener("click", function () {
      const isOpen = header.classList.contains("_isOpen");
      toggleButton.setAttribute("aria-expanded", !isOpen);
      header.classList.toggle("_isOpen");

      if (isOpen) {
  document.body.classList.add("no-scroll");
} else {
  document.body.classList.remove("no-scroll");
}

    });
  
    document.addEventListener("click", function (e) {
if (!navMenu.contains(e.target) && !toggleButton.contains(e.target)) {
        header.classList.remove("_isOpen");
        toggleButton.setAttribute("aria-expanded", "false");
      }
    });
  
    menuLinks.forEach(link => {
      link.addEventListener("click", function () {
        header.classList.remove("_isOpen");
        toggleButton.setAttribute("aria-expanded", "false");
      });
    });
  });
  

  // 
// 要素がフワッて上がってくる、5%〜50%範囲に入っている間だけ表示
// 

document.addEventListener('DOMContentLoaded', () => {
  const fadeElements = document.querySelectorAll('.flow-cont');

  function isInMiddleViewport(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const topLimit = windowHeight * -0.05;
    const bottomLimit = windowHeight * 0.5;

    return (
      rect.top < bottomLimit && rect.bottom > topLimit
    );
  }

  // アニメーション処理の最適化
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        fadeElements.forEach(el => {
          if (isInMiddleViewport(el)) {
            el.classList.remove('_isHidden');
          } else {
            el.classList.add('_isHidden');
          }
        });
        ticking = false;
      });
      ticking = true;
    }
  }

fadeElements.forEach(el => {
  if (!isInMiddleViewport(el)) {
    el.classList.add('_isHidden');
  }
});

  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onScroll);
  onScroll(); // 初回
});


  document.addEventListener("DOMContentLoaded", function () {
    const popup = document.querySelector('.popup');
    const popupClose = document.querySelector('.popup-close');

    // サイト訪問時に_activeクラスを追加
    if (popup) {
      popup.classList.add('_active');
    }

    // popup全体またはcloseボタンがクリックされたら_activeを削除
    const closePopup = () => {
      if (popup) {
        popup.classList.remove('_active');
      }
    };

    // 閉じるボタン
    if (popupClose) {
      popupClose.addEventListener('click', closePopup);
    }

    // popup自体をクリックで閉じる（中身のクリックでは閉じないように制御）
    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        closePopup();
      }
    });
  });

  // 
// アコーディオン
// 
document.querySelectorAll('.accordionWrap').forEach(accordion => {
  const toggleBtn = accordion.querySelector('.accordion-btn');
  const closeBtn = accordion.querySelector('.accordion-close');
  const content = accordion.querySelector('.accordion');

  // アニメーション後、autoに切り替える（動的対応のため）
  content.addEventListener('transitionend', () => {
    if (accordion.classList.contains('_open')) {
      content.style.height = 'auto'; // ←ここがキモ
    }
  });

  const openAccordion = () => {
    // 1. 一度 height を auto にして、scrollHeight を正確に取得
    content.style.height = 'auto';
    const height = content.scrollHeight + 'px';

    // 2. 一度リセットしてからアニメーション用に数値を代入
    content.style.height = '0px'; // ← これがないと transition 効かない
    requestAnimationFrame(() => {
      content.style.height = height;
    });

    accordion.classList.add('_open');
  };

  const closeAccordion = () => {
    // 1. 固定値にしてアニメーション
    content.style.height = content.scrollHeight + 'px';

    // 2. 直後に 0 に戻す
    requestAnimationFrame(() => {
      content.style.height = '0px';
      accordion.classList.remove('_open');
    });
  };

  toggleBtn.addEventListener('click', e => {
    e.preventDefault();
    if (accordion.classList.contains('_open')) {
      closeAccordion();
    } else {
      openAccordion();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', e => {
      e.preventDefault();
      closeAccordion();
    });
  }

  // 初期化
  content.style.height = '0';
});